import { render, staticRenderFns } from "./fila_cirurgias.vue?vue&type=template&id=2c9e3400"
import script from "./fila_cirurgias.vue?vue&type=script&lang=js"
export * from "./fila_cirurgias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports